const home = {
    popup: {
        date: 'The new Osogovo Run date is September 27, 2026!',
        registration: 'Registration will open soon.',
    },
    footer: 'Copyright © 2025 Osogovo Run',
    route: {
        scrollPrompt: 'See more',
        distance: '{{distance}}km',
        elevation: '{{elevation}} m D+',
        coldSpring: {
            name: 'Studen<br/> Kladenets',
            altitude: '1340 m',
        },
        hut: {
            name: 'Osogovo<br/> Hut',
            altitude: '1640 m',
        },
        begBunar: {
            name: 'Beg Bunar',
            altitude: '1842 m',
        },
        ruen: {
            name: 'Ruen',
            altitude: '2251 m',
        },
    },
    products: {
        start: 'Start',
        finish: 'Finish',
        startTime: 'Start time',
        totalDistance: 'Total distance',
        elevation: 'Elevation gain',
        cutOffTime: 'Cut-off time',
        fee: 'Fee',
        register: 'Register',
        downloadGpx: 'Click to download',
        osogovoRun14: {
            name: 'Osogovo Run',
            start: 'Velbazhd Square, Kyustendil',
            finish: 'Osogovo Hut',
            startTime: '9:00',
            totalDistance: '14 km',
            elevation: '1100 m',
            cutOffTime: '12:30',
            description: 'Osogovo Run is a mountain running race in the Osogovo Mountains. The race offers routes through scenic landscapes and demanding terrain.',
        },
        ruenRun26: {
            name: 'Osogovo Ultramarathon',
            start: 'Velbazhd Square, Kyustendil',
            finish: 'Ruen Peak',
            startTime: '09:00',
            totalDistance: '27 km',
            elevation: '1700 m',
            cutOffTime: '14:30',
            description: 'Ruen Run is a challenge for experienced runners who want to take on a longer and more demanding mountain route in the Osogovo Mountains.',
        },
    },
    course: {
        title: 'Course',
        description: 'The race starts at Velbazhd Square in the center of Kyustendil (530 m). The route passes by the stadium, karting track and Pochivalo, then follows a forest road below Iglika Hut to Studen Kladenets. Before Pamuka it reaches the asphalt road and after 2 km arrives at Osogovo Hut, from where Ruen Peak is climbed through Beg Bunar along the summer trail on the main ridge marked in red. The return from the peak to the hut is self-supported, with transport from the hut back to town.',
        feesTitle: 'Entry Fees',
        distanceLabel: '{{distance}} km',
        earlyFee: '/ early fee',
        regularFee: '/ regular fee',
        lateFee: '/ late fee',
        register: 'Register',
    },
    records: {
        title: 'Course records',
        holder: 'Record holder',
        time: 'Time',
        bonus: 'Current record bonus for improving the record to Ruen Peak:',
        note: 'If the bonus is not awarded this year, the amount accumulates into next year\'s record bonus.',
        male: {
            title: 'Male',
        },
        female: {
            title: 'Female',
        },
    },
    details: {
        conditionsTitle: 'Participation Terms',
        conditions: 'Open to physically and mentally healthy participants from 15 to 75 years of age. Participants must follow the markings and obey traffic rules before, during and after the race. Participants who do not provide a pre-race medical check at registration start at their own risk. Participation costs are covered by the participants. Carrying an ID card is mandatory for long-distance participants because the course enters a border zone.',
        transportTitle: 'Transport',
        transportFinish: '<b>Transport after finishing:</b> from the parking area at Osogovo Hut by bus back to the start. The first bus departs after 13:00 when seats are filled.',
        transportLuggage: '<b>Luggage transport:</b> participants can hand over luggage to be transported from the start to the finish. Luggage must be given to the organizers by 8:50 on race day.',
        programTitle: 'Race Day Program | 26.09.2027',
        programRegistration: '<b>8:00-8:45</b> Registration in the start area',
        programStart: '<b>9:00</b> START for all distances',
        programEnd: '<b>14:30</b> finish area closes',
        contactsTitle: 'Contacts',
        socialsPrompt: 'Follow us on social media:',
    },
};

export default home;
